export function getMenusOfStandaloneApp(menuId, appId, helpers) {
  var _ref, _storyboard$meta$inje, _storyboard$meta, _storyboard$meta2;
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const storyboard = helpers.getStoryboardByAppId(appId);
  const menus = (_ref = (_storyboard$meta$inje = (_storyboard$meta = storyboard.meta) === null || _storyboard$meta === void 0 ? void 0 : _storyboard$meta.injectMenus) !== null && _storyboard$meta$inje !== void 0 ? _storyboard$meta$inje : (_storyboard$meta2 = storyboard.meta) === null || _storyboard$meta2 === void 0 ? void 0 : _storyboard$meta2.menus) !== null && _ref !== void 0 ? _ref : [];
  return menus.filter(menu => menu.menuId === menuId).map(menu => {
    var _menu$app;
    return {
      ...menu,
      ...((_menu$app = menu.app) !== null && _menu$app !== void 0 && (_menu$app = _menu$app[0]) !== null && _menu$app !== void 0 && _menu$app.appId ? {} : {
        app: [{
          appId
        }]
      })
    };
  });

  // Todo: maybe: fetch menus from STANDALONE_MENU@EASYOPS
}
//# sourceMappingURL=getMenusOfStandaloneApp.js.map